const typeInputChoice = 'Input.ChoiceSet';

export const mockFeedbackRequest = {
	requestedOn: '2024-08-06T11:34:08.197379Z',
	interviewer: 'John Doe',
	hiringManager: 'Jane Smith',
	recruiter: 'Alex Johnson',
	feedbackState: 'IN_PROGRESS',
	questionGroupName: 'Software Engineer Interview Feedback',
	jobTitle: 'Principle Software Engineer',
	jobLocation: 'Holmdel, NJ',
	formCard: {
		$schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
		type: 'AdaptiveCard',
		version: '1.2',
		body: [
			{
				type: 'TextBlock',
				size: 'Medium',
				weight: 'Bolder',
				text: 'Software Engineer Interview Feedback',
				horizontalAlignment: 'Center',
				wrap: true,
			},
			{
				type: 'TextBlock',
				text: 'Comments',
				wrap: true,
			},
			{
				type: 'Input.Text',
				style: 'text',
				isRequired: true,
				isMultiline: true,
				id: 'MultiLineVal',
			},
			{
				type: 'Input.Rating',
				id: 'rating1',
				label: 'Pick a rating',
				value: '',
			},
			{
				type: 'Input.Recommendation',
				id: 'rec1',
				label: 'Do you think the candidate is fit for this position?',
				value: '',
			},
			{
				type: 'TextBlock',
				text: 'Interview Date',
				wrap: true,
			},
			{
				type: 'Input.Date',
				id: 'DateVal',
				value: '2017-09-20',
			},
			{
				type: 'TextBlock',
				text: 'What is your role?',
				wrap: true,
			},
			{
				type: typeInputChoice,
				id: 'CompactSelectVal',
				value: '1',
				choices: [
					{
						title: 'Hiring Manager',
						value: 'HM',
					},
					{
						title: 'Engineer',
						value: 'engineer',
					},
					{
						title: 'Recruiter',
						value: 'recruiter',
					},
				],
			},
			{
				type: 'TextBlock',
				text: 'Was the candidate on time?',
				wrap: true,
			},
			{
				type: typeInputChoice,
				id: 'SingleSelectVal',
				style: 'expanded',
				value: '1',
				choices: [
					{
						title: 'Yes',
						value: '1',
					},
					{
						title: 'No',
						value: '0',
					},
				],
			},
			{
				type: 'TextBlock',
				text: 'Verified Skills',
				wrap: true,
			},
			{
				type: typeInputChoice,
				id: 'MultiSelectVal',
				isMultiSelect: true,
				value: '1,3',
				choices: [
					{
						title: 'Java',
						value: 'java',
					},
					{
						title: 'C#',
						value: 'C#',
					},
					{
						title: 'JavaScript',
						value: 'js',
					},
					{
						title: 'React',
						value: 'react',
					},
				],
			},
		],
		actions: [
			{
				type: 'Action.Submit',
				title: 'Submit Feedback',
				data: {
					id: '1234567890',
					feedbackState: 'SUBMITTED',
				},
			},
			{
				type: 'Action.Submit',
				title: 'Save Draft',
				data: {
					id: '1234567891',
					feedbackState: 'IN_PROGRESS',
				},
			},
		],
	},
	feedbackRequestId: 'FEEDBACK_REQUEST_ID',
	feedbackRequestStatus: 'ACTIVE',
	intervieweeName: 'Stephen Kane',
	customerId: '1',
	intervieweeId: '1',
	jobId: '1',
};

export const mockJobDescription = {
	id: '2001',
	number: '2025-2001',
	code: 'ENG2025',
	folder: {
		id: 'F12345',
		name: 'Engineering',
		template: true,
	},
	title: 'Senior Software Engineer',
	overview:
		'<p style="margin: 0px;">This is a mock overview for the Senior Software Engineer position.</p>',
	responsibilities:
		'<p style="margin: 0px;">These are the mock responsibilities for the Senior Software Engineer position.</p>',
	qualifications:
		'<p style="margin: 0px;">These are the mock qualifications for the Senior Software Engineer position.</p>',
	locations: [
		{
			id: '1',
			entry: '0',
			companyId: '10',
			companyName: 'Mock Company',
			name: 'Mock Company - 456 Elm St, Springfield, Illinois, United States',
			address: {
				addressLine1: '456 Elm St',
				adminArea2: 'Springfield',
				adminArea1: 'Illinois',
				countryCode: 'US',
				country: 'United States',
				primary: true,
			},
		},
	],
	positionType: {
		id: 'PT123',
		name: 'Permanent Full-Time',
	},
	positionSchedule: 'PART_TIME',
	numberOfPositions: 2,
	hireType: {
		id: 'HT456',
		name: 'Replacement',
		replaces: true,
	},
	createdAt: '2025-01-01T12:00:00Z',
	updatedAt: '2025-03-01T12:00:00Z',
	hiringManager: {
		id: 'HM789',
		name: {
			displayName: 'Chris Manager, chris.manager@mock.com',
		},
	},
	recruiter: {
		id: 'R101',
		name: {
			displayName: 'Pat Recruiter, pat.recruiter@mock.com',
		},
	},
	status: 'CLOSED',
	link: 'http://mockcompany.com/job/2001',
};

export const mockResumeLink = {
	id: '12345678-1234-1234-1234-123456789012',
	filename: 'John_Doe_Resume.pdf',
	folderId: 'us:12345678-1234-1234-1234-123456789012',
	link: '/resume-link',
	createdAt: '2025-01-01T12:00:00Z',
	latest: true,
};
